export var ImportType;
(function (ImportType) {
    ImportType["TM"] = "TM";
    ImportType["SALTO"] = "SALTO";
    ImportType["CUSTOMER_LINK"] = "CUSTOMER_LINK";
})(ImportType || (ImportType = {}));
